import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goto } from '../../../../actions/historyActions';
import { resolveLocalizedText } from '../../../../utils';
import { getCustomerProfileResetUsenameOrPasswordConfirmConfig } from '../../selectors/customerProfileResetUNOrPWConfirmSelectors';
import { getCustomerProfileCurrentUpdateKey } from '../../selectors/customerProfileResetUNOrPWSelectors';
import { ChangeContactView } from '../../components/ChangeContactView';
import browserHistory from '../../../../stores/browserHistory';
import './style.scss';
import {
  trackUpdateContactSuccess,
  TrackUpdateContactSuccessAction,
  TrackUpdateContactSuccessContent,
} from '../../../../utils/generalGaEventAnalytics';

export interface CustomerResetPasswordConfirmProps {
  curUpdateKey: string;
  passwordTitle: string;
  passwordSuccess: string;
  passwordDesc: string;
  buttonText: string;
  stepContext: any;
}

export interface CustomerResetPasswordConfirmState {}

export class CustomerResetPasswordConfirm extends Component<
  CustomerResetPasswordConfirmProps,
  CustomerResetPasswordConfirmState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { curUpdateKey } = this.props;
    !curUpdateKey && goto('emma-customer-profile-resetusenameorpassword');
    trackUpdateContactSuccess(
      TrackUpdateContactSuccessContent.PASSWORD,
      TrackUpdateContactSuccessAction.UPDATE,
    );
  }

  onGoBack = () => {
    browserHistory.goBack();
  };

  render() {
    const {
      passwordTitle,
      passwordSuccess,
      passwordDesc,
      buttonText,
      stepContext,
    } = this.props;

    return (
      <div className="customer-reset-confirm">
        <ChangeContactView
          onGoBack={this.onGoBack}
          pageName={passwordTitle ? resolveLocalizedText(passwordTitle) : ''}
          stepContext={stepContext}
          activeIndex={3}
        >
          <div className="customer-reset-confirm-container emma-stylesheet-grid-system">
            <div className="customer-reset-confirm-container-text">
              {passwordSuccess}
            </div>
            <div>{passwordDesc}</div>
            <div className="customer-reset-confirm-container-button">
              <button
                className="emma-stylesheet-primary-default-button"
                data-enable-ga
                data-ga-type="button"
                onClick={() =>
                  goto('emma-customer-profile-resetusenameorpassword')
                }
              >
                {buttonText}
              </button>
            </div>
          </div>
        </ChangeContactView>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const labelConfig =
      getCustomerProfileResetUsenameOrPasswordConfirmConfig(state);
    const curUpdateKey = getCustomerProfileCurrentUpdateKey(state);
    return {
      curUpdateKey,
      passwordTitle: labelConfig.passwordTitle
        ? resolveLocalizedText(labelConfig.passwordTitle)
        : '',
      passwordSuccess: labelConfig.passwordSuccess
        ? resolveLocalizedText(labelConfig.passwordSuccess)
        : '',
      passwordDesc: labelConfig.passwordDesc
        ? resolveLocalizedText(labelConfig.passwordDesc)
        : '',
      buttonText: labelConfig.buttonText
        ? resolveLocalizedText(labelConfig.buttonText)
        : '',
      stepContext: labelConfig.stepContext
        ? resolveLocalizedText(labelConfig.stepContext)
        : '',
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  CustomerResetPasswordConfirm.mapStateToProps,
  CustomerResetPasswordConfirm.mapDispatchToProps,
)(CustomerResetPasswordConfirm);
